import request from '@/utils/request'
import api from '../api'

export class Common {
  queryFile(data) {
    return request({
      url: api.common.queryFile,
      method: 'post',
      data
    })
  }
  dictSearch(data) {
    return request({
      url: api.common.dictSearch,
      method: 'post',
      data
    })
  }
  all_constants(params) {
    return request({
      url: api.common.all_constants,
      method: 'get',
      params
    })
  }
  all_banks(params) {
    return request({
      url: api.common.all_banks,
      method: 'get',
      params
    })
  }
  all_system_constants(params) {
    return request({
      url: api.common.all_system_constants,
      method: 'get',
      params
    })
  }
  allCurrency(params) {
    return request({
      url: api.common.allCurrency,
      method: 'get',
      params
    })
  }
  allCountry(params) {
    return request({
      url: api.common.allCountry,
      method: 'get',
      params
    })
  }
}

